<section
  class="z-[9999] fixed flex items-center justify-center inset-0 w-screen h-screen p-4"
  [ngClass]="{ 'bg-black/60': hasBackdrop() }"
>
  <article class="select-none">
    <ng-template dialog></ng-template>
  </article>
</section>
